/*
 * @Author: Jun
 * @Date: 2021-03-24 16:48:06
 * @LastEditTime: 2021-03-24 16:50:10
 * @LastEditors: JUN
 * @Description:
 * @FilePath: /guokr-ad/src/views/CC/index.tsx
 */
import { makeStyles, Theme } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import Tab from "@material-ui/core/Tab"
import Tabs from "@material-ui/core/Tabs"
import InsertInvitationIcon from '@material-ui/icons/InsertInvitation'
import ListAltIcon from '@material-ui/icons/ListAlt'
import DutyIcon from "@material-ui/icons/AccessAlarm"
import SwipeViews from "react-swipeable-views"
import React, { Fragment, useState, useContext } from "react"
import { AppContext } from "../Home/context"
import Calendar from "Components/Calendar"
import TabPanel from "./TabPanel"
import { HealthCalendarTab } from "Types/app"
const tabArray: HealthCalendarTab[] = [
    {
        value: "health_board",
        text: "果壳病人",
        icon: <InsertInvitationIcon />,
    }, {
        value: "health_article_type",
        text: "文章类型",
        icon: <ListAltIcon />,
    }, {
        value: "health_operation_person",
        text: "值班运营",
        icon: <DutyIcon/>,
        where: {
            hidden: {
                _eq: false
            }
        },
    },
]
const useStyles = makeStyles((theme: Theme) => ({
    "@global": {
        "#root": {
            display: "flex",
        },
    },
    root: {
        backgroundColor: theme.palette.background.paper,
    },
    tabIndicator: {
        height: 0,
    },
    tabItem: {
        lineHeight: 1,
        marginTop: 4,
        borderRadius: theme.shape.borderRadius,
        fontSize: 14,
        minHeight: 0,
    },
    selectedItem: {
        backgroundColor: "#ff9800",
        color: "white",
        borderWidth: 0,
    },
}))

export default function HealthCalendar() {
    const classes = useStyles()
    const [index, setIndex] = useState(0)

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setIndex(newValue)
    }
    const handleChangeIndex = (index: number) => {
        setIndex(index)
    }
    const { privilegeMap, user } = useContext(AppContext)
    return (
        <div className={classes.root}>
            <Tabs
                value={index}
                onChange={handleChange}
                classes={{
                    indicator: classes.tabIndicator,
                }}
                centered
            >
                {
                    tabArray.map((tab: HealthCalendarTab, index) => (
                        <Tab
                            label={tab.text}
                            icon={tab.icon}
                            key={tab.value}
                            value={index}
                            classes={{
                                root: classes.tabItem,
                                selected: classes.selectedItem,
                            }}
                        />
                    ))
                }
            </Tabs>
            <SwipeViews
                index={index}
                onChangeIndex={handleChangeIndex}
            >
                {
                    tabArray.map((tab: HealthCalendarTab, index) => {
                        switch (tab.value) {
                            case 'health_board':

                                return (
                                    <Fragment>
                                        <Calendar channelName={'果壳病人'} />

                                        <Typography component="div">
                                            <pre style={{whiteSpace: 'pre-line'}}>
                                                预约规则：<br />
                                                1.需求只能预约头条或二条，且每天选择1个。<br />
                                                2.除内容部外，其它所有部门头条需求预约不能连续3天。<br />
                                                3.头条二条需求不能相连。<br />
                                                备注：<br />
                                                1.【需求】指非内容部文章，包括广告、营销文章、招聘文章、市场置换等。<br />
                                                2.此处规则仅以文字形式告知，系统未做限制，请自觉遵守。<br />
                                                3.有问题请联系冯颖或小树。<br />
                                            </pre>
                                        </Typography>
                                    </Fragment>
                                )

                            default:
                                return (
                                    <TabPanel tab={tab} index={index} key={index} privilegeMap={privilegeMap} />
                                )
                        }
                    })
                }
            </SwipeViews>
            <div id="board_input_modal" />
            <div id="child_article_type_modal" />
        </div>
    )
}
